import axios from 'axios';
import { ACCESS_TOKEN, API_BASE_URL } from './consts';

export interface TokenValidationResponse {
    valid: boolean;
    user?: any;
}

export class AuthService {
    /**
   * Validates the current token with the backend
   */
    static async validateToken(): Promise<TokenValidationResponse> {
        const token = localStorage.getItem(ACCESS_TOKEN);

        if (!token) {
            return { valid: false };
        }

        try {
            // Note: No need to add Authorization header manually - interceptor handles it
            const { data } = await axios.get(`${API_BASE_URL}/auth/validate-token`);

            return {
                valid: true,
                user: data.user
            };
        } catch (error: any) {
            // Token is invalid or expired - interceptor will handle logout
            return { valid: false };
        }
    }

    /**
   * Checks if token exists and is properly formatted
   */
    static hasValidTokenFormat(): boolean {
        const token = localStorage.getItem(ACCESS_TOKEN);

        if (!token) {
            return false;
        }

        // Basic JWT format check (header.payload.signature)
        const parts = token.split('.');
        if (parts.length !== 3) {
            return false;
        }

        try {
            // Check if token is expired based on exp claim
            const payload = JSON.parse(atob(parts[1]));
            const currentTime = Math.floor(Date.now() / 1000);

            if (payload.exp && payload.exp < currentTime) {
                return false;
            }

            return true;
        } catch (error) {
            return false;
        }
    }

    /**
     * Removes invalid token from storage
     */
    static clearInvalidToken(): void {
        localStorage.removeItem(ACCESS_TOKEN);
    }
}